<div class="flex flex-col items-center justify-center h-screen">
    <p-toast></p-toast>
    
    <div class="flex flex-col items-center justify-center border border-gray-200 rounded-lg p-10 mx-5 md:mx-0 lg:min-w-[450px]">
        <img src="assets/logo.png" alt="Office Global Logo" class=" h-[60px] object-contain">
            
        <h1 class="text-2xl font-bold mt-2" i18n>Forgot Password</h1>
        <p class="text-base text-gray-500 mt-2" i18n>Enter your email address to get the reset link</p>

        <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" class="w-full">
            <div class="w-full flex flex-col gap-2 mt-5 mb-20">
                <div class="w-full flex items-center justify-start">
                    <label class="text-start" for="username" i18n>Email</label>
                </div>
                <p-inputgroup>
                    <p-inputgroup-addon>
                        <i class="pi pi-user"></i>
                    </p-inputgroup-addon>
                    <input pInputText formControlName="email" i18n-placeholder placeholder="e.g jacob.jhon@purple" />
                </p-inputgroup>
                <small class="text-red-500" *ngIf="forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched" i18n>
                    Please enter a valid email address
                </small>
            </div>


            <p-button i18n-label label="Send Password Reset Link" class="w-full !w-full mb-4" type="submit" [disabled]="forgotPasswordForm.invalid"
                [loading]="loading"></p-button>

        </form>
        
        <div class="w-full flex flex-col gap-2">
            <button type="button" class="text-gray-600 hover:text-gray-800 text-sm cursor-pointer mt-5" (click)="onBackToLogin()" i18n>
                Back to Login
            </button>
        </div>
    </div>
</div>